import { defineStore } from "pinia";
import { ref } from "vue";

export const useDuplicatedOrderStore = defineStore("duplicatedOrder", () => {
  const duplicatedOrderData = ref(null);
  // Flag de carga secuencial: mientras es true, los watchers que disparan
  // recargas (fotocromáticos, focomaterial, loadAllLentes...) deben abstenerse
  // para no generar llamadas duplicadas en paralelo con la secuencia controlada.
  const isLoadingOrder = ref(false);

  function setDuplicatedOrder(data) {
    duplicatedOrderData.value = data;
  }

  function clearDuplicatedOrder() {
    duplicatedOrderData.value = null;
  }

  function setLoadingOrder(value) {
    isLoadingOrder.value = !!value;
  }

  return {
    duplicatedOrderData,
    isLoadingOrder,
    setDuplicatedOrder,
    clearDuplicatedOrder,
    setLoadingOrder,
  };
});
